import { createContext, useContext } from 'react';

type AuthLayoutState = {
  // The layout already shows the Vida logo (on the carousel, or atop a phone browser's page).
  brandPanel: boolean;
  // The form sits on the mobile sheet over the carousel.
  inSheet: boolean;
};

export const AuthLayoutContext = createContext<AuthLayoutState>({ brandPanel: false, inSheet: false });

export const useAuthLayout = (): AuthLayoutState => useContext(AuthLayoutContext);
